// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".heading[data-v-980160c8]{color:#343333;font-weight:700;text-transform:uppercase}h1[data-v-980160c8]{font-size:1.625rem;margin-bottom:1.75rem}@media(min-width:48em){h1[data-v-980160c8]{font-size:2.375rem;margin-bottom:4rem}}@media(min-width:64em){h1[data-v-980160c8]{font-size:4.5rem;margin-bottom:4.5rem}}h2[data-v-980160c8]{font-size:1.125rem}@media(min-width:64em){h2[data-v-980160c8]{font-size:1.5rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
